import { render, staticRenderFns } from "./PetEventsGroup.vue?vue&type=template&id=13498692&scoped=true"
import script from "./PetEventsGroup.vue?vue&type=script&lang=js"
export * from "./PetEventsGroup.vue?vue&type=script&lang=js"
import style0 from "./PetEventsGroup.vue?vue&type=style&index=0&id=13498692&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13498692",
  null
  
)

export default component.exports